var _path, _path2, _path3, _path4, _path5, _circle, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPeopleCounting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3065 39.0234V64.4929M28.9032 64.4929V39.0234",
    stroke: "#CCCFD1",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3571 38.482V19.2207C33.3571 18.1161 32.4617 17.2207 31.3571 17.2207H18.5405C17.436 17.2207 16.5405 18.1161 16.5405 19.2207V38.482",
    stroke: "#CCCFD1",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8108 13.135C26.6916 13.135 28.2162 11.6104 28.2162 9.72962C28.2162 7.84887 26.6916 6.32422 24.8108 6.32422C22.93 6.32422 21.4054 7.84887 21.4054 9.72962C21.4054 11.6104 22.93 13.135 24.8108 13.135Z",
    fill: "#CCCFD1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2499 17.2207H46.1844C47.289 17.2207 48.1844 18.1161 48.1844 19.2207V36.536",
    stroke: "#CCCFD1",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3783 13.135C42.2591 13.135 43.7837 11.6104 43.7837 9.72962C43.7837 7.84887 42.2591 6.32422 40.3783 6.32422C38.4976 6.32422 36.9729 7.84887 36.9729 9.72962C36.9729 11.6104 38.4976 13.135 40.3783 13.135Z",
    fill: "#CCCFD1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.1351,
    cy: 52.0547,
    r: 10.9122,
    stroke: "#CCCFD1",
    strokeWidth: 2.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2703 51.3132L48.0527 54.7794L54.4865 48.4551",
    stroke: "#CCCFD1",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPeopleCounting);
export default __webpack_public_path__ + "static/media/icon-people-counting.c6dcecf3b40032e459031bb0249fabe3.svg";
export { ForwardRef as ReactComponent };